import { Menu, Tooltip } from "antd";
import { useUser } from "../../contexts/UserContext";
import { setSelectedId, setSelectedTitle } from "../../redux/slices/selectItemDrawerMenu";
import { useDispatch } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";
import { useState, useEffect, useRef } from "react";
import TruncatedText from "../../helpers/TruncatedText";
import { FETCH_PRODUCT_LIST } from "../../redux/actions";

const DrawerMenu = ({ data }) => {

    const [activeItem, setActiveItem] = useState(null);
    const [menuStack, setMenuStack] = useState([]);
    const [isMobile, setIsMobile] = useState(window.innerWidth <= 640);
    const [selectedItem, setSelectedItem] = useState(null);
    const menuBoxRef = useRef(null);

    const location = useLocation();
    let currentPage = location.pathname;

    const navigate = useNavigate();
    const { SubMenu } = Menu;
    const { userConfigs } = useUser();
    const dispatch = useDispatch();

    const handleItemClick = (id, name) => {

        dispatch(setSelectedId(id));
        dispatch(setSelectedTitle(name));
        setActiveItem(id)
        dispatch({ type: FETCH_PRODUCT_LIST });

        if (currentPage !== '/') {
            navigate('/');
        }

    };


    const handleItemClickMobile = (item) => {
        dispatch(setSelectedId(item.id));
        dispatch(setSelectedTitle(item.name));
        setActiveItem(item.id)
        dispatch({ type: FETCH_PRODUCT_LIST });


        if (isMobile) {
            setMenuStack([...menuStack, item]);
            setSelectedItem(item);
            if (currentPage !== '/') {
                navigate('/');
            }
        }
    };

    const handleBack = () => {
        setMenuStack(menuStack.slice(0, -1));
        setSelectedItem(menuStack.length > 1 ? menuStack[menuStack.length - 2] : null);
    };


    useEffect(() => {
        const handleClickOutside = (event) => {
            if (menuBoxRef.current && !menuBoxRef.current.contains(event.target)) {
                setSelectedItem(null); // Close the menu box
            }
        };

        if (selectedItem) {
            document.addEventListener("mousedown", handleClickOutside);
        }

        return () => {
            document.removeEventListener("mousedown", handleClickOutside);
        };
    }, [selectedItem]);


    useEffect(() => {
        const handleResize = () => {
            setIsMobile(window.innerWidth <= 992);
        };

        window.addEventListener("resize", handleResize);
        return () => window.removeEventListener("resize", handleResize);
    }, []);

    return (
        <>
            {!isMobile && (
                <Menu mode="inline" className={'drawerMenu drawerMenuSidebarCollapse'} style={{ marginTop: '20px', marginInline: '0px', marginLeft: '0px' }}>
                    {data?.map((item) => (
                        <SubMenu
                            style={{ marginBottom: '15px', marginInline: '0px' }}
                            key={`sub1-${item.id}`}
                            title={
                                <div style={{ display: 'flex', alignItems: 'center', marginInline: '0px' }} onClick={() => handleItemClick(item.id, item.name)}>
                                    {
                                        item.icon ?
                                            <div className='home-menu-image-collapse'>
                                                <img
                                                    src={item.icon}
                                                    alt=""
                                                    width="24px"
                                                    height="24px"
                                                />
                                            </div>
                                            :
                                            <div className={''} style={{
                                                width: '20px',
                                                height: '20px',
                                                borderRadius: '50%',
                                                backgroundColor: userConfigs.dark ? 'white' : 'black',
                                            }}></div>
                                    }
                                    {!userConfigs.collapsed && <span style={{ fontSize: '14px', fontWeight: 'bold', marginLeft: '8px' }}>{item.name}</span>}
                                </div>
                            }
                        >
                            {item.children?.map((child) => (
                                <SubMenu
                                    key={`sub2-${child.id}`}
                                    className=""
                                    title={
                                        <div
                                            style={{ cursor: "pointer", fontSize: '14px', color: activeItem === child.id ? '#FFB035' : 'inherit' }}
                                            onClick={() => handleItemClick(child.id, child.name)}
                                        >
                                            {child.name}
                                        </div>
                                    }
                                    style={{ paddingLeft: 10 }}
                                >
                                    {
                                        child.children?.map((subChild) => (
                                            subChild.children.length > 0 ? (
                                                <SubMenu
                                                    key={`sub4-${subChild.id}`}
                                                    title={
                                                        <div
                                                            style={{ cursor: "pointer", fontSize: '14px' }}
                                                            onClick={() => handleItemClick(subChild.id, subChild.name)}
                                                        >
                                                            {subChild.name}
                                                        </div>
                                                    }
                                                    style={{ paddingLeft: 10 }}
                                                >
                                                    {subChild.children?.map((leaf) => (
                                                        <Menu.Item
                                                            key={`itemsdes-${leaf.id}`}
                                                            style={{ paddingLeft: 15, fontSize: '14px', color: activeItem === leaf.id ? '#FFB035' : 'inherit' }}
                                                            className={`${userConfigs.dark ? 'ex-menu-item-dark' : 'ex-menu-item'} leaf-menu leaf-sub-menu`}
                                                            onClick={() => handleItemClick(leaf.id, leaf.name)}
                                                        >
                                                            {leaf.name}
                                                        </Menu.Item>
                                                    ))}
                                                </SubMenu>
                                            ) : (
                                                <Menu.Item
                                                    key={`itemdes-${subChild.id}`}
                                                    style={{ paddingLeft: 15, fontSize: '14px', color: activeItem === subChild.id ? '#FFB035' : 'inherit' }}
                                                    className={`${userConfigs.dark ? 'ex-menu-item-dark' : 'ex-menu-item'} leaf-menu leaf-sub-menu`}
                                                    onClick={() => handleItemClick(subChild.id, subChild.name)}
                                                >
                                                    {subChild.name}
                                                </Menu.Item>
                                            )
                                        ))}
                                </SubMenu>
                            ))}
                        </SubMenu>
                    ))}
                </Menu>

            )}

            {isMobile && (
                <div className="drawer-container">
                    <Menu mode="inline" className="drawerMenu drawerMenuSidebarCollapse" style={{ marginTop: '20px' }}>
                        {data?.map((item) => (
                            <Tooltip title={null}>
                                <Menu.Item
                                    title={null}
                                    key={item.id}
                                    onClick={() => handleItemClickMobile(item)}
                                    style={{ fontSize: '14px', color: '#333', cursor: 'pointer' }}
                                >
                                    {item?.icon && (
                                        <img src={item.icon} alt="" width="20px" height="20px" style={{ marginRight: '8px' }} />
                                    )}
                                    {item?.name}
                                </Menu.Item>
                            </Tooltip>
                        ))}
                    </Menu>

                    {isMobile && selectedItem && (
                        <div ref={menuBoxRef} className={userConfigs.dark ? "mobile-menu-box mobile-menu-box-dark" : 'mobile-menu-box'}>
                            <button className="back-button" onClick={handleBack}>← Back</button>
                            <h3 className={userConfigs.dark ? "mobile-menu-title-selected mobile-menu-title-selected-dark" : 'mobile-menu-title-selected'}>{selectedItem?.name}</h3>
                            {selectedItem?.children?.map((child) => (
                                <div
                                    style={{ paddingLeft: '8px', cursor: 'pointer' }}
                                    key={child.id}
                                    className={userConfigs.dark ? "menu-item menu-item-dark" : "menu-item"}
                                    onClick={() => handleItemClickMobile(child)}
                                >
                                    {child?.name}
                                </div>
                            ))}
                        </div>
                    )}
                </div>
            )}
        </>
    );
};

export default DrawerMenu;
